<template>
  <div class="container-fluid" style="background-color: #f7f6fe">
    <div class="row">
      <div class="col-md-12">
        <div
          class="text-white rounded-3 p-4 bg-azul d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <img
              src="@/assets/images/icons/campana-publicitaria.png"
              alt="Globe icon"
              class="me-2"
            />
            <span>BANNER DE OFERTAS</span>
          </div>
          <button class="btn btn-link text-white">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="row mt-4 text-center">
      <div class="col-md-2">
        <div class="card p-4">
          <div class="d-flex justify-content-center align-items-center">
            <img
              src="@/assets/images/icons/aprender-en-linea.png"
              alt="Icono de laptop"
              width="15%"
            />
          </div>
          <p class="mt-2">Cursos Matriculados</p>
          <span
            class="p-2 text-white rounded-3"
            style="background-color: #f05769"
          >
            {{ cantidad_cursos }}
          </span>
        </div>
      </div>
      <div class="col-md-2">
        <div class="card p-4">
          <div class="d-flex justify-content-center align-items-center">
            <img
              src="@/assets/images/icons/ganador.png"
              alt="Icono de certificado"
              width="15%"
            />
          </div>
          <p class="mt-2">Certificados</p>
          <span
            class="p-2 text-white rounded-3"
            style="background-color: #f05769"
          >
            {{ certificados }}
          </span>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col--md-12">
        <h5>Cursos que estás Tomando</h5>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-3" v-for="c in cursos_matriculados" :key="c.id">
        <div
          class="card"
          @click="irModulos(c.curso.id)"
          style="cursor: pointer"
        >
          <img
            :src="getImagenUrl(c.curso.imagen)"
            class="card-img-top"
            alt="Curso"
          />
          <div class="card-body">
            <h6 class="card-title" @click="irModulos(c.curso.id)">
              {{ c.curso.nombre }}<br />
              <span class="" style="font-size: 11px"
                >{{ c.curso.horas }} Horas</span
              >
            </h6>
          </div>
        </div>
      </div>
    </div>
    <Preloader :visible="cargando" />
  </div>
</template>

<script>
import MatriculaService from "@/services/MatriculaService";
import CertificadoService from "@/services/CertificadoService";
import Preloader from "../components/Preloader.vue";
export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      cantidad_cursos: "",
      certificados: "",
      cursos_matriculados: [],
      id_cliente: "",
      cargando: false,
    };
  },
  components: {
    Preloader,
  },
  mounted() {
    if (this.user) {
      this.obtenerEstadisticas(this.user.id);
      this.obtenerCertificados(this.user.id);
    }
  },
  methods: {
    irModulos(id) {
      this.$router.push({
        name: "Modulos",
        params: {
          id_curso: id,
        },
      });
    },
    getImagenUrl(imagen) {
      if (imagen) {
        return process.env.VUE_APP_API_URL + "/storage/" + imagen;
      } else {
        return require("@/assets/images/fondos/curso-defecto.png");
      }
    },
    async obtenerEstadisticas(id) {
      try {
        this.cargando = true;
        const responseMatriculas =
          await MatriculaService.getCursosMatriculadosPorUsuario(id);
        this.cantidad_cursos = responseMatriculas.data.data.length;
        this.cursos_matriculados = responseMatriculas.data.data;

        this.cursosTomando = responseMatriculas.data.filter(
          (curso) => curso.estado === "en_progreso"
        );
      } catch (error) {
        console.error("Error al obtener estadísticas:", error);
      } finally {
        this.cargando = false;
      }
    },
    async obtenerCertificados(id) {
      try {
        const responseCertificados =
          await CertificadoService.getcertificadoPorUsuario(id);
        this.certificados = responseCertificados.data.data.length;
      } catch (error) {
        console.error("Error al obtener certificados:", error);
      }
    },
  },
};
</script>

<style lang="">
</style>
